import { jsx as _jsx } from "react/jsx-runtime";
import { colors as dsColors } from '@modernhealth/vital-foundation';
import { ReactComponent as CheckmarkEnclosedFilled } from './assets/icons/checkmark-enclosed-filled.svg';
import { ReactComponent as CheckmarkEnclosed } from './assets/icons/checkmark-enclosed.svg';
import { ReactComponent as Checkmark } from './assets/icons/checkmark.svg';
import { ReactComponent as Chevron } from './assets/icons/chevron.svg';
import { ReactComponent as ChevronLeft } from './assets/icons/chevron-left.svg';
import { ReactComponent as Close } from './assets/icons/close.svg';
import { ReactComponent as InfoEnclosedFilled } from './assets/icons/info-enclosed-filled.svg';
import { ReactComponent as WarningEnclosedFilled } from './assets/icons/warning-enclosed-filled.svg';
import { ReactComponent as XEnclosedFilled } from './assets/icons/x-enclosed-filled.svg';
import { ReactComponent as TriangleDown } from './assets/icons/triangle-down.svg';
import { ReactComponent as TriangleUp } from './assets/icons/triangle-up.svg';
import { ReactComponent as ChevronDown } from './assets/icons/chevron-down.svg';
import { ReactComponent as ChevronUp } from './assets/icons/chevron-up.svg';
import { ReactComponent as CalendarDate } from './assets/icons/calendar-date.svg';
import { ReactComponent as Chat } from './assets/icons/chat.svg';
import { ReactComponent as ChatSquare } from './assets/icons/chat-square.svg';
import { ReactComponent as Circles } from './assets/icons/circles.svg';
import { ReactComponent as Compass } from './assets/icons/compass.svg';
import { ReactComponent as Lock } from './assets/icons/lock.svg';
import { ReactComponent as Star } from './assets/icons/star.svg';
import { ReactComponent as X } from './assets/icons/x.svg';
import { ReactComponent as Hamburger } from './assets/icons/hamburger.svg';
import { ReactComponent as ArrowDown } from './assets/icons/arrow-down.svg';
import { ReactComponent as ArrowUp } from './assets/icons/arrow-up.svg';
import { ReactComponent as ArrowLeft } from './assets/icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from './assets/icons/arrow-right.svg';
import { ReactComponent as QuestionEnclosedFilled } from './assets/icons/question-enclosed-filled.svg';
import { ReactComponent as EyeOpen } from './assets/icons/eye-open.svg';
import { ReactComponent as EyeClosed } from './assets/icons/eye-closed.svg';
import { ReactComponent as Location } from './assets/icons/location.svg';
import { ReactComponent as Globe } from './assets/icons/globe.svg';
import { ReactComponent as QuestionEnclosed } from './assets/icons/question-enclosed.svg';
import { ReactComponent as XEnclosed } from './assets/icons/x-enclosed.svg';
import { ReactComponent as WarningEnclosed } from './assets/icons/warning-enclosed.svg';
import { ReactComponent as FaceSad } from './assets/icons/face-sad.svg';
import { ReactComponent as FaceContent } from './assets/icons/face-content.svg';
import { ReactComponent as FaceHappy } from './assets/icons/face-happy.svg';
import { ReactComponent as FaceNeutral } from './assets/icons/face-neutral.svg';
import { ReactComponent as InfoEnclosed } from './assets/icons/info-enclosed.svg';
import { ReactComponent as MinusEnclosed } from './assets/icons/minus-enclosed.svg';
import { ReactComponent as PlusEnclosed } from './assets/icons/plus-enclosed.svg';
import { ReactComponent as AlertEnclosed } from './assets/icons/alert-enclosed.svg';
import { ReactComponent as FaceSadFilled } from './assets/icons/face-sad-filled.svg';
import { ReactComponent as FaceContentFilled } from './assets/icons/face-content-filled.svg';
import { ReactComponent as FaceHappyFilled } from './assets/icons/face-happy-filled.svg';
import { ReactComponent as FaceNeutralFilled } from './assets/icons/face-neutral-filled.svg';
import { ReactComponent as ChatFilled } from './assets/icons/chat-filled.svg';
import { ReactComponent as MinusEnclosedFilled } from './assets/icons/minus-enclosed-filled.svg';
import { ReactComponent as PlusEnclosedFilled } from './assets/icons/plus-enclosed-filled.svg';
import { ReactComponent as AlertEnclosedFilled } from './assets/icons/alert-enclosed-filled.svg';
import { ReactComponent as CareTeam } from './assets/icons/care-team.svg';
import { ReactComponent as Handshake } from './assets/icons/handshake.svg';
import { ReactComponent as Megaphone } from './assets/icons/megaphone.svg';
import { ReactComponent as UserEnclosed } from './assets/icons/user-enclosed.svg';
import { ReactComponent as Headphones } from './assets/icons/headphones.svg';
import { ReactComponent as Home } from './assets/icons/home.svg';
import { ReactComponent as Meditation } from './assets/icons/meditation.svg';
import { ReactComponent as More } from './assets/icons/more.svg';
import { ReactComponent as Video } from './assets/icons/video.svg';
import { ReactComponent as Clock } from './assets/icons/clock.svg';
import { ReactComponent as CalendarX } from './assets/icons/calendar-x.svg';
import { ReactComponent as CalendarCheckmark } from './assets/icons/calendar-checkmark.svg';
import { ReactComponent as Calendar } from './assets/icons/calendar.svg';
import { ReactComponent as Stacks } from './assets/icons/stacks.svg';
import { ReactComponent as Photo } from './assets/icons/photo.svg';
import { ReactComponent as MagnifyingGlass } from './assets/icons/magnifying-glass.svg';
import { ReactComponent as Mindfulness } from './assets/icons/mindfulness.svg';
import { ReactComponent as Flag } from './assets/icons/flag.svg';
export var IconTestID;
(function (IconTestID) {
    IconTestID["Icon"] = "IconTestID.Icon";
})(IconTestID || (IconTestID = {}));
const icons = {
    'arrow-down': ArrowDown,
    'arrow-up': ArrowUp,
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'chevron-down': ChevronDown,
    'chevron-up': ChevronUp,
    'chevron-left': ChevronLeft,
    'chevron-right': Chevron,
    'triangle-up': TriangleUp,
    'triangle-down': TriangleDown,
    x: X,
    checkmark: Checkmark,
    'eye-open': EyeOpen,
    'eye-closed': EyeClosed,
    location: Location,
    globe: Globe,
    'question-enclosed': QuestionEnclosed,
    'x-enclosed': XEnclosed,
    'checkmark-enclosed': CheckmarkEnclosed,
    'warning-enclosed': WarningEnclosed,
    'face-sad': FaceSad,
    'face-content': FaceContent,
    'face-happy': FaceHappy,
    'face-neutral': FaceNeutral,
    chat: Chat,
    'info-enclosed': InfoEnclosed,
    'minus-enclosed': MinusEnclosed,
    'plus-enclosed': PlusEnclosed,
    'alert-enclose': AlertEnclosed,
    'question-enclosed-filled': QuestionEnclosedFilled,
    'x-enclosed-filled': XEnclosedFilled,
    'checkmark-enclosed-filled': CheckmarkEnclosedFilled,
    'warning-enclosed-filled': WarningEnclosedFilled,
    'face-sad-filled': FaceSadFilled,
    'face-content-filled': FaceContentFilled,
    'face-happy-filled': FaceHappyFilled,
    'face-neutral-filled': FaceNeutralFilled,
    'chat-filled': ChatFilled,
    'info-enclosed-filled': InfoEnclosedFilled,
    'minus-enclosed-filled': MinusEnclosedFilled,
    'plus-enclosed-filled': PlusEnclosedFilled,
    'alert-enclosed-filled': AlertEnclosedFilled,
    'care-team': CareTeam,
    handshake: Handshake,
    megaphone: Megaphone,
    'user-enclosed': UserEnclosed,
    headphones: Headphones,
    home: Home,
    meditation: Meditation,
    star: Star,
    more: More,
    video: Video,
    clock: Clock,
    'calendar-x': CalendarX,
    'calendar-checkmark': CalendarCheckmark,
    calendar: Calendar,
    stacks: Stacks,
    photo: Photo,
    'magnifying-glass': MagnifyingGlass,
    mindfulness: Mindfulness,
    hamburger: Hamburger,
    flag: Flag,
    close: Close,
    'calendar-date': CalendarDate,
    circles: Circles,
    compass: Compass,
    lock: Lock,
    'chat-square': ChatSquare,
};
export const iconNames = Object.keys(icons);
const Name = 'Icon';
export const Icon = ({ name, className, color = 'inherit', size = 16, ...ariaProps }) => {
    const IconComponent = icons[name];
    const iconColor = dsColors[color] ?? color;
    return (_jsx(IconComponent, { ...ariaProps, className: className, "data-testid": `${IconTestID.Icon}_${name}`, "data-component": Name, color: iconColor, height: size, width: size }));
};
